import { useCallback, useState } from 'react';
import { Button, GridRenderCellParams } from '@bymason-private/legacy-pattern-components';
import { ProvisionQRCodeModel } from '@bymason/controller-api-hooks';
import { useRouter } from '@bymason-private/route-provider';
import {
  DevicesList,
  GenerateDeviceReportModal,
  CreateQRCodeModal,
  useToast,
} from '@bymason-private/controller-shared-widgets';
import Layout from '../../common/layout';
import NoDevices from './no-devices';
import { routes } from '../../router';

export default function DevicesView() {
  const { navigate } = useRouter();
  const [setToastMessage, setToastSeverity] = useToast();
  const [showGenReportModal, setShowGenReportModal] = useState(false);
  const [showCreateQRCodeModal, setShowCreateQRCodeModal] = useState(false);

  const handleCloseGenReportModal = () => {
    setShowGenReportModal(false);
  };

  const handleOpenGenReportModal = () => {
    setShowGenReportModal(true);
  };

  const handleClickUuidLink = useCallback(
    (params: GridRenderCellParams) => {
      navigate(routes.Device, { deviceId: params.value as string, subView: 'info' });
    },
    [navigate]
  );

  const handleOpenCreateQRCodeModal = () => {
    setShowCreateQRCodeModal(true);
  };

  const handleCreateQRCodeModalClose = () => {
    setShowCreateQRCodeModal(false);
  };

  const handleProvisionCodeSuccess = useCallback(
    (qrCodeData?: ProvisionQRCodeModel, provisionSessionId?: string) => {
      setShowCreateQRCodeModal(false);
      if (qrCodeData && provisionSessionId) {
        navigate(routes.Provision, { qrCodeData, provisionSessionId });
      }
    },
    [navigate]
  );

  const handleProvisionCodeError = useCallback(
    (message: string) => {
      setToastSeverity('error');
      setToastMessage(message);
    },
    [setToastMessage, setToastSeverity]
  );

  return (
    <Layout
      headerText='Devices'
      headerRightAdornment={
        <div style={{ display: 'flex', gap: 8 }}>
          <Button variant='outlined' onClick={handleOpenGenReportModal}>
            Generate report
          </Button>
          <Button variant='outlined' onClick={handleOpenCreateQRCodeModal}>
            Provision
          </Button>
        </div>
      }
      stickyHeader
    >
      <DevicesList topOffsetPx={75} onClickUuidLink={handleClickUuidLink} noDataMessage={<NoDevices />} />
      <GenerateDeviceReportModal open={showGenReportModal} onClose={handleCloseGenReportModal} />
      {showCreateQRCodeModal && (
        <CreateQRCodeModal
          open={showCreateQRCodeModal}
          onClose={handleCreateQRCodeModalClose}
          onSuccess={handleProvisionCodeSuccess}
          onError={handleProvisionCodeError}
        />
      )}
    </Layout>
  );
}
